export enum Permission {
  // care_admin.embedded_cx_admin_app
  CareAdminEmbeddedCxAdminAppView = 'care_admin.embedded_cx_admin_app.view',

  // care_admin.customers.address
  CareAdminCustomersAddressView = 'care_admin.customers.address.view',
  CareAdminCustomersAddressUpdate = 'care_admin.customers.address.update',
  CareAdminCustomersAddressCreate = 'care_admin.customers.address.create',

  // care_admin.customers.appeasements
  CareAdminCustomersAppeasementsView = 'care_admin.customers.appeasements.view',

  // care_admin.customers.details
  CareAdminCustomersDetailsView = 'care_admin.customers.details.view',
  CareAdminCustomersDetailsViewExtendedInfo = 'care_admin.customers.details.view_extended_info',
  CareAdminUpdateName = 'care_admin.customers.details.update_name',
  CareAdminUpdatePhone = 'care_admin.customers.details.update_phone_number',
  CareAdminCustomersDetailsImpersonate = 'care_admin.customers.details.impersonate',
  CareAdminCustomersDetailsLinkUser = 'care_admin.customers.details.link_user',
  CareAdminCustomersDetailsUnlinkUser = 'care_admin.customers.details.unlink_user',
  CareAdminCustomersDetailsReactivate = 'care_admin.customers.details.reactivate',

  // care_admin.customers.notes
  CareAdminCustomersNotesView = 'care_admin.customers.notes.view',
  CareAdminCustomersNotesCreate = 'care_admin.customers.notes.create',

  // care_admin.customers.subscriptions.instacart_plus
  CareAdminCustomersSubscriptionsInstacartPlusView = 'care_admin.customers.subscriptions.instacart_plus.view',
  CareAdminCustomersSubscriptionsInstacartPlusAddFreeMonth = 'care_admin.customers.subscriptions.instacart_plus.add_free_month',
  CareAdminCustomersSubscriptionsInstacartPlusCancel = 'care_admin.customers.subscriptions.instacart_plus.cancel',
  CareAdminCustomersSubscriptionsInstacartPlusToggleAutorenew = 'care_admin.customers.subscriptions.instacart_plus.toggle_autorenew',

  // care_admin.customers.notifications
  CareAdminCustomersNotificationsView = 'care_admin.customers.notifications.view',
  CareAdminCustomersNotificationsCreate = 'care_admin.customers.notifications.create',

  // care_admin.customers.orders
  CareAdminCustomersOrdersView = 'care_admin.customers.orders.view',

  // care_admin.customers.restaurant_orders
  CareAdminCustomersRestaurantOrdersView = 'care_admin.customers.restaurant_orders.view',

  // care_admin.customers.shopper_bans
  CareAdminCustomersShopperBansView = 'care_admin.customers.shopper_bans.view',
  CareAdminCustomersShopperBansCreate = 'care_admin.customers.shopper_bans.create',
  CareAdminCustomersShopperBansDelete = 'care_admin.customers.shopper_bans.delete',

  // care_admin.customers.search
  CareAdminCustomersSearchView = 'care_admin.customers.search.view',
  CareAdminCustomersSearchFastFind = 'care_admin.customers.search.fast_find',
  CareAdminCustomersSearchLatest = 'care_admin.customers.search.latest',

  // care_admin.orders.appeasements
  CareAdminOrdersAppeasementsView = 'care_admin.orders.appeasements.view',

  // care_admin.orders.details
  CareAdminOrdersDetailsDefaultLookBack = 'care_admin.orders.details.default_look_back',
  CareAdminOrdersDetailsUnlimitedLookBack = 'care_admin.orders.details.unlimited_look_back',
  CareAdminOrdersDetailsLatest = 'care_admin.orders.details.latest',
  CareAdminOrdersDetailsViewDeliveryInfo = 'care_admin.orders.details.view_delivery_info',

  // care_admin.orders.links
  CareAdminOrdersLinksStatusLink = 'care_admin.orders.links.status_link',
  CareAdminOrdersLinksReceiptLink = 'care_admin.orders.links.receipt_link',
  CareAdminOrdersLinksPhotoLink = 'care_admin.orders.links.photo_link',

  // care_admin.orders.notes
  CareAdminOrdersNotesView = 'care_admin.orders.notes.view',

  // care_admin.orders.drivers
  CareAdminOrdersDriversView = 'care_admin.orders.drivers.view',

  // care_admin.orders.return_batch
  CareAdminOrdersReturnBatchPerformCheck = 'care_admin.orders.return_batch.perform_check',
  CareAdminOrdersReturnBatchCreate = 'care_admin.orders.return_batch.create',
}
